import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./ui/dialog";

const Impressum = () => {
  const { t } = useLanguage();
  const imp = t.impressum;

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="hover:text-cyan-400 transition-colors duration-200">
          {t.footer.impressum}
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto bg-black border border-cyan-500/30 text-gray-300">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent mb-4">
            {imp.title}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-6 text-sm">
          <section>
            <h3 className="text-white font-semibold mb-2">{imp.commercialRegister.title}</h3>
            <p>{imp.commercialRegister.name}</p>
            <p>{imp.address}</p>
            <p>{imp.commercialRegister.number}</p>
            <p>{imp.commercialRegister.office}</p>
            <p className="mt-2">Email: {imp.email}</p>
          </section>

          <section>
            <h3 className="text-white font-semibold mb-2">{imp.representatives.title}</h3>
            <p>{imp.representatives.names}</p>
          </section>

          <section>
            <h3 className="text-white font-semibold mb-2">{imp.vatNumber.title}</h3>
            <p>{imp.vatNumber.number}</p>
          </section>

          <section>
            <h3 className="text-white font-semibold mb-2">{imp.webdesign.title}</h3>
            <p>{imp.webdesign.name}</p>
            <p>{imp.webdesign.address}</p>
            <p>Email: {imp.webdesign.email}</p>
          </section>

          <section>
            <h3 className="text-white font-semibold mb-2">{imp.disclaimer.title}</h3>
            <p className="leading-relaxed">{imp.disclaimer.content}</p>
          </section>

          <section>
            <h3 className="text-white font-semibold mb-2">{imp.links.title}</h3>
            <p className="leading-relaxed">{imp.links.content}</p>
          </section>

          <section>
            <h3 className="text-white font-semibold mb-2">{imp.copyright.title}</h3>
            <p className="leading-relaxed">{imp.copyright.content}</p>
          </section>

          <footer className="text-xs text-gray-500 pt-4 border-t border-gray-800">
            Quelle: Dieses Impressum wurde am 07.03.2018 mit dem Impressum-Generator http://www.bag.ch/impressum-generator der Firma Brunner Medien AG in Kriens erstellt.
          </footer>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Impressum;
